import { render, staticRenderFns } from "./eventAdminList.vue?vue&type=template&id=70706247&"
import script from "./eventAdminList.vue?vue&type=script&lang=js&"
export * from "./eventAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70706247')) {
      api.createRecord('70706247', component.options)
    } else {
      api.reload('70706247', component.options)
    }
    module.hot.accept("./eventAdminList.vue?vue&type=template&id=70706247&", function () {
      api.rerender('70706247', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/robot/admin/event/eventAdminList.vue"
export default component.exports